import {Progress} from 'antd';
import {useMemo} from 'react';

import {Text} from '../../../../component/text/text';
import {
    lps_semi_circle_progress_high_rating_color,
    lps_semi_circle_progress_low_rating_color,
    lps_semi_circle_progress_medium_rating_color,
} from '../../../../css/var-export.scss';

import * as styles from './lps-card.scss';

interface LpsCardProps {
    title: string;
    value: number;
    secondaryText: string;
}

function formatProgress(percent?: number): JSX.Element {
    return (
        <Text bold large>
            {percent}
        </Text>
    );
}

export function LpsCard({title, value, secondaryText}: LpsCardProps): JSX.Element {
    const getColor = useMemo(() => {
        if (value < 50) {
            return lps_semi_circle_progress_low_rating_color;
        }

        if (value < 80) {
            return lps_semi_circle_progress_medium_rating_color;
        }

        return lps_semi_circle_progress_high_rating_color;
    }, [value]);

    return (
        <div className={styles.LpsCard}>
            <Text bold>{title}</Text>
            <div className={styles.LpsCard_content}>
                <Progress
                    format={formatProgress}
                    percent={value}
                    showInfo
                    size={[71, 71]}
                    strokeColor={getColor}
                    strokeWidth={10}
                    type="circle"
                />
                <Text secondary>{secondaryText}</Text>
            </div>
        </div>
    );
}
